import '@testing-library/jest-dom';
import { render, screen } from '@testing-library/react';

import { Notification } from './Notification';

describe('Notification', () => {
  it('renders title and subtitle', () => {
    render(<Notification level="information" title="Info title" subtitle="Info subtitle" />);
    expect(screen.getByText('Info title')).toBeInTheDocument();
    expect(screen.getByText('Info subtitle')).toBeInTheDocument();
  });

  it('renders bar variant', () => {
    render(<Notification level="danger" variant="bar" title="Danger title" />);
    expect(screen.getByText('Danger title')).toBeInTheDocument();
  });
});
